module.exports = __webpack_public_path__ + "static/media/notaCertaBlack.eb1a11dd.png";